import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineSend } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { BiStopCircle, BiPlusCircle } from "react-icons/bi";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { IoRefresh } from "react-icons/io5";
import "../../../../styles/searchDetails.css";
import SyncFusionDateTimePicker from "../../SyncFusionDateTimePicker/SyncFusionDateTimePicker";

export const SearchDetails = (props) => {
  const { t } = useTranslation();
  
  return (
    <div className="card-details">
      <div
        className="filter-details"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="filters-details-main">
          <span>{t("SEARCH.SEARCH")}</span>

          <div className="field" style={{ marginRight: 8, marginLeft: 8 }}>
            <SyncFusionDateTimePicker
              id="datetimepickerStart"
              value={props.startDate}
              onChange={props.setStartDate}
              placeholder={t("SEARCH.INITIAL_DATE_TIME")}
              step={30}
            />
          </div>

          <div className="field" style={{ marginRight: 8 }}>
            <SyncFusionDateTimePicker
              id="datetimepickerStart"
              value={props.endDate}
              onChange={props.setEndDate}
              placeholder={t("SEARCH.FINAL_DATE_TIME")}
              step={30}
            />
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-mapa-search">{t("SEARCH.SEARCH")}</Tooltip>}
            >
              <button
                type="button"
                className={`btn btn-outline-secondary`}
                onClick={() => props.search && props.search()}
              >
                <FaSearch className="icon-in-button-frotas" size={18} />
                <span>{t("SEARCH.SEARCH")}</span>
              </button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-mapa-1">{t("SEARCH.UPDATE_PAGE")}</Tooltip>}
            >
              <button
                type="button"
                className={`btn btn-outline-secondary`}
                onClick={() => props.refresh()}
              >
                <IoRefresh className="icon-in-button-frotas" size={18} />
                <span>{t("SEARCH.UPDATE")}</span>
              </button>
            </OverlayTrigger>
          </div>
        </div>
        <div className="filter-details-secondary">
          <div style={{ marginRight: 8 }}>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-mapa-2">{`${
                  props.underMaintenace === "S" 
                    ? t("MAINTENANCE.REMOVE") 
                    : t("MAINTENANCE.REGISTER")
                } ${t("MAINTENANCE.MAINTENANCE")}`}</Tooltip>
              }
            >
              <button
                type="button"
                className={`btn btn-outline-secondary`}
                onClick={() => props.handleActiveMaintenace()}
              >
                {props.underMaintenace === "S" ? (
                  <BiStopCircle className="icon-in-button-frotas" size={18} />
                ) : (
                  <BiPlusCircle className="icon-in-button-frotas" size={18} />
                )}
                <span>{t("MAINTENANCE.MAINTENANCE")}</span>
              </button>
            </OverlayTrigger>
          </div>

          <div style={{ marginRight: 8 }}>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-mapa-3">{t("COMMANDS.SEND_COMMANDS")}</Tooltip>}
            >
              <button
                type="button"
                className={`btn btn-outline-secondary`}
                onClick={async () => props.handleShowCommands()}
              >
                <HiOutlineWrenchScrewdriver
                  className="icon-in-button-frotas"
                  size={18}
                />
                <span>{t("COMMANDS.COMMANDS")}</span>
              </button>
            </OverlayTrigger>
          </div>

          <div style={{ marginRight: 8 }}>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-mapa-4">{t("COMMANDS.COMMAND_HISTORY")}</Tooltip>
              }
            >
              <button
                type="button"
                className={`btn btn-outline-secondary`}
                onClick={async () => props.handleActiveCommands()}
              >
                <AiOutlineSend className="icon-in-button-frotas" size={18} />
                <span>{t("FLEET.HISTORY")}</span>
              </button>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </div>
  );
};